import React, { Component } from 'react';
import style from './index.module.css';

// interface PopupProps {
//   answerFlag: boolean;
//   content: string;
//   type: number;
// //   cancelText: '取消';
// //   confirmText: '确定';
//   // cancelCbk: Function,
//   // confirmCbk: Function,
// }
interface ModelState {
  time: number;
}

class PopupModel extends Component<any, ModelState> {
  interval: any;
  constructor(props) {
    super(props);
    this.state = {
      time: 0
    };
  }

  componentDidMount() {
    if (this.props.seconds > 0) {
      const time = Math.round(this.props.seconds / 1000);
      this.setState({
        time
      });
      this.interval = setInterval(() => {
        const next = this.state.time - 1;
        if (next) {
          this.setState({
            time: next
          });
        } else {
          this.setState({
            time: 0
          });
          if (this.props.end) {
            this.props.end();
          }
          this.stop();
        }
      }, 1000);
    }
  }

  componentWillUnmount() {
    this.stop();
  }

  stop() {
    clearInterval(this.interval);
    this.interval = null;
  }

  renderbtn = () => {
    const { type, cancelText, confirmText, confirmCbk } = this.props;
    const { time } = this.state;

    return (
      <div className={style.btnBox}>
        {type === 1 && (
          <div
            className={style.btn}
            onClick={(): void => {
              this.props.cancelCbk();
            }}
          >
            {cancelText}
          </div>
        )}
        {type === 2 && (
          <div className={style.btn}>
            <div
              className={style.cancelText}
              onClick={(): void => {
                this.props.cancelCbk();
              }}
            >
              {cancelText}
            </div>
            <div
              className={time > 0 ? style.confirmGrayText : style.confirmText}
              onClick={(): void => {
                if (time > 0) return;
                confirmCbk();
              }}
            >
              {confirmText}
              {time > 0 ? '(' + time + ')' : null}
            </div>
          </div>
        )}
      </div>
    );
  };

  renderContent = () => {
    const { content, tip, copyright, copyrightFlag } = this.props;
    return (
      <div className={style.modelContentBox}>
        <div>
          <p className={style.title}>{content}</p>
          <p
            className={style.tips}
            style={{
              whiteSpace: 'pre-wrap',
              textAlign: !!copyright && copyrightFlag ? 'left' : 'center'
            }}
          >
            {tip}
            {!!copyright && copyrightFlag && <br />}
            {!!copyright && copyrightFlag && (
              <span style={{ opacity: 0.3 }}>{copyright}</span>
            )}
          </p>
        </div>
        {this.renderbtn()}
      </div>
    );
  };

  render() {
    return (
      <div className={style.yearlyPopupModel}>
        <div className={style.popupMask} />
        {this.renderContent()}
      </div>
    );
  }
}

export default PopupModel;
